import * as Sentry from '@sentry/browser';
import { Integrations as TracingIntegrations } from "@sentry/tracing";

// Use TraceKit to detect and collect data on unhandled exceptions
if (!App.isProduction) {
   window.__wd_unique = Math.random();
   window.__js_errors = [];
   var onError = window.onerror;
   window.onerror = function(message, url, lineNo) {
      if (onError) {
         onError(message, url, lineNo);
      }
      window.__js_errors.push(message);
   };
}

var sentrySent = false;

const sampleRate = App.isProduction ? 0.005 : 0.1;
const forceSentry = App.isAdmin && window.location.search.match(/(forceSentry)/);
const performanceOptions = App.sentryPerformance ? {
    integrations: [new TracingIntegrations.BrowserTracing()],
    tracesSampleRate: sampleRate
   } : {};

Sentry.init({
   dsn: App.SENTRY_DSN,
   environment: App.isProduction ? 'production' : 'dev',
   sampleRate: forceSentry ? 1 : sampleRate,
   ...performanceOptions,
   // Limit to one error per page load please cause we've seen instances of
   // thousands of errors being sent by one user.
   beforeSend: function(event) {
      if (sentrySent) {
         return null;
      }

      sentrySent = true;
      return event;
   },
});

Sentry.setTags(App.sentryTags);
